<div class="bg-gray-50 rounded-medium overflow-y-auto p-8 shadow-[0_4px_18px_0_rgba(0,0,0,0.17)] md:w-[540px] "
  *transloco="let t; prefix: 'general-callback-modal'">
  <div class="flex flex-col text-center">
    <div class="flex flex-col gap-2">
      <div class="flex justify-end">
        <div class="flex flex-col">
          <h2 class="text-[28px] text-black text-left">{{t('title')}}</h2>
          <p class="text-left">{{t('subtitle')}}</p>
        </div>
        <button class="p-2 self-start" (click)="close()"><i class="icon-close text-xl"></i></button>
      </div>
      <div class="divider-line1 border-b-tone-05 my-4"></div>
      <div class="flex flex-col gap-7">
        <div class="flex flex-col bg-gray-100 rounded-[16px] text-left p-5">
          <p class="text-gray-900">{{t('phone-number')}}</p>
          <p class="text-secondary-900 text-[28px]">+30 2102040000</p>
        </div>
      </div>

      <div class="max-w-[290px] w-full h-full self-center mt-14">
        <img src="../../../../assets/img/general-callback.png" alt="" class="object-fit">
      </div>
      <a class="btn-primary font-bold mt-16 self-start mx-auto" href="tel:++302102203340"><i
          class="icon-phonecall mr-1"></i>{{t('buttons.call')}}</a>
    </div>
  </div>
</div>